import { CheckCircleTwoTone, PlusOutlined, UserOutlined, DeleteOutlined, EditOutlined } from "@ant-design/icons"
import { Avatar, Button, Flex, Table, Tabs, Typography, Popconfirm } from "antd"
import { useEffect, useState } from "react";
import { get, xdelete } from "../services/api";
import dayjs from "dayjs";
import calendar from 'dayjs/plugin/calendar';
import relativeTime from 'dayjs/plugin/relativeTime';
import TransactionCreate from "../components/TransactionCreate";
import TransactionEdit from "../components/TransactionEdit";
dayjs.extend(relativeTime)
dayjs.extend(calendar)

export default function Transactions () {
  const [transactions, setTransactions] = useState([]);
  const [transaction, setTransaction] = useState({});
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [totalCount, setTotalCount] = useState(0);
  const [currentFilter, setCurrentFilter] = useState({ order: 'startAt DESC' });

  const showModal = () => {
    setIsModalOpen(true);
  };
  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      render: (name) => {
        return <div className="avatar-with-profile">
          <Avatar size={40} style={{ minWidth: "40px" }} icon={<UserOutlined />} />
          <div className="heading-with-tagline">
            <a href="#">{name}</a>
            <span></span>
          </div>
        </div>
      },
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      render: (amount, {startAt, endAt}) => {
        console.log(startAt, endAt);
        return <div className="heading-with-tagline">
          <Typography.Text className="amount" type={ amount < 0 ? "danger" : "success" }>{
            new Intl.NumberFormat('en-IN', {
              style: 'currency',
              currency: 'INR',
              maximumFractionDigits: 2
            }).format(Math.abs(amount))
          }</Typography.Text>
          <span>for { startAt && endAt ? dayjs(startAt).to(endAt, true) : 'a unit' }</span>
        </div>
      },
    },
    {
      title: 'Start Date',
      render: ({startAt, amount, createdAt}) => {
        return <div className="heading-with-tagline">
          <Typography.Text style={{ fontSize: "14px" }} type={ amount < 0 ? "primary" : "primary" }>
            { startAt ? dayjs(startAt).format('MMMM D, YYYY') : dayjs(createdAt).format('MMMM D, YYYY') }
          </Typography.Text>
        </div>
      },
    },
    {
      title: 'End Date',
      render: ({endAt, amount, createdAt}) => {
        return <div className="heading-with-tagline">
          <Typography.Text style={{ fontSize: "14px" }} type={ amount < 0 ? "primary" : "primary" }>
            { endAt ? dayjs(endAt).subtract(1, 'second').format('MMMM D, YYYY') : dayjs(createdAt).format('MMMM D, YYYY') }
          </Typography.Text>
        </div>
      },
    },
    {
      title: 'Actions',
      render: (transaction) => {
        return transaction?.settled ?  <><CheckCircleTwoTone /><Button onClick={() => showEditModal(transaction)} type="default" shape="circle" icon={<EditOutlined />}></Button></> : <>
            <Button onClick={() => showEditModal(transaction)} type="default" shape="circle" icon={<EditOutlined />}></Button>
            <Popconfirm
              title="Delete Transaction"
              placement="bottomRight"
              description="Are you sure to delete this Transaction?"
              onConfirm={() => deleteTransaction(transaction)}
              onCancel={console.log}
              okText="Yes"
              cancelText="No"
            >
              <Button shape="circle" icon={<DeleteOutlined />} />
            </Popconfirm></>
        },
      }
  ];


  const deleteTransaction = async (transaction) => {
    await xdelete(`/transactions/${transaction.id}`);
    await refreshTransactions();
  };

  const showEditModal = (transaction) => {
    console.log('Transaction data:', transaction); // Check what fields are coming from API
    setTransaction(transaction)
    setIsEditModalOpen(true);
  };
  const refreshTransactions = async (filter = { order: 'startAt DESC' }, page = currentPage, size = pageSize) => {
    setCurrentFilter(filter);
    const skip = (page - 1) * size;
    const paginatedFilter = {
      ...filter,
      limit: size,
      skip: skip
    };

    // Fetch transactions
    const transactionsData = await get("/transactions", paginatedFilter);
    setTransactions(transactionsData);

    // Fetch total count
    const countFilter = filter.where ? { where: filter.where } : {};
    const count = await get("/transactions/count", countFilter);
    setTotalCount(count.count);
  }
  const selectType = async (type) => {
    setCurrentPage(1); // Reset to first page when changing filter
    if(type === 'all') { return refreshTransactions({ order: 'startAt DESC' }, 1) }
    else if(type === 'settled') { await refreshTransactions({ order: 'startAt DESC', where : { settled: 1 } }, 1) }
    else if(type === 'settled_credits') { await refreshTransactions({ order: 'startAt DESC', where : { settled: 1, amount: {gt: 0} } }, 1) }
    else if(type === 'settled_debits') { await refreshTransactions({ order: 'startAt DESC', where : { settled: 1, amount: {lt: 0} } }, 1) }
    else if(type === 'unsettled') { await refreshTransactions({ order: 'startAt DESC', where : { settled: 0 } }, 1) }
    else if(type === 'unsettled_credits') { await refreshTransactions({ order: 'startAt DESC', where : { settled: 0, amount: {gt: 0}  } }, 1) }
    else if(type === 'unsettled_debits') { await refreshTransactions({ order: 'startAt DESC', where : { settled: 0, amount: {lt: 0}  } }, 1) }
  }

  const handleTableChange = (pagination) => {
    setCurrentPage(pagination.current);
    setPageSize(pagination.pageSize);
    refreshTransactions(currentFilter, pagination.current, pagination.pageSize);
  };
  useEffect(() => {
    refreshTransactions();
  }, []);
  
  return <Flex gap={20}>
    <div style={{ marginLeft: '16px' }}>
      <Button type="primary" className="align bold" icon={<PlusOutlined />} style={{ margin: "10px 0 36px" }} onClick={showModal}>
        Add Transaction
      </Button>
      <Tabs
        defaultActiveKey="1"
        tabPosition={'left'}
        size="small"
        style={{ width: "200px" }}
        onChange={selectType}
        items={[{
          label: `All`,
          key: 'all'
        },{
          label: `Settled`,
          key: 'settled'
        },{
          label: `Settled Credits`,
          key: 'settled_credits'
        },{
          label: `Settled Debits`,
          key: 'settled_debits'
        },{
          label: `Unsettled`,
          key: 'unsettled'
        },{
          label: `Unsettled Credits`,
          key: 'unsettled_credits'
        },{
          label: `Unsettled Debits`,
          key: 'unsettled_debits'
        }]}
      />
    </div>
    <Table
      style={{ flex: '1', marginRight: '16px' }}
      scroll={{ y: window.innerHeight-120 }}
      pagination={{
        current: currentPage,
        pageSize: pageSize,
        total: totalCount,
        showSizeChanger: true,
        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} transactions`,
        pageSizeOptions: ['5', '10', '20', '50', '100']
      }}
      onChange={handleTableChange}
      dataSource={transactions}
      rowKey={'id'}
      columns={columns}
    />
    <TransactionCreate isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} onTransactionCreate={refreshTransactions}/>
    <TransactionEdit isModalOpen={isEditModalOpen} setIsModalOpen={setIsEditModalOpen} onTransactionEdit={refreshTransactions} transaction={transaction} setTransaction={setTransaction}/>
  </Flex>
}